/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DenyTrialExtensionPayload, TrialExtensionRequest } from '@ca/core/models';
import { extendDate } from '@ca/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

type Action = 'approve' | 'deny';

@Component({
    selector: 'ca-extend-trial-actions-dialog',
    templateUrl: './extend-trial-actions-dialog.component.html',
    styleUrls: ['./extend-trial-actions-dialog.component.scss'],
})
export class ExtendTrialActionsDialogComponent implements OnInit {
    @Input() action: Action;
    @Input() request: TrialExtensionRequest;
    @Output() onSubmit = new EventEmitter<void | DenyTrialExtensionPayload>();
    formGroup: UntypedFormGroup;

    get modalTitle(): any {
        return this.translateService.instant(
            `MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.${
                this.action === 'deny' ? 'DENY_TITLE' : this.request.customerType === 'IndustryTrial' ? 'APPROVE_TITLE' : 'CONFIRM_TITLE'
            }`,
        );
    }

    get email(): any {
        return this.translateService.instant('MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.EMAIL', {
            email: this.request.email,
        });
    }

    get type(): any {
        return this.translateService.instant('MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.TYPE', {
            type: this.request.customerType,
        });
    }

    get newEndDate(): any {
        const today: Date = new Date();
        let endDate: Date = new Date(this.request.endDate);

        if (this.action === 'deny') {
            return this.translateService.instant('MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.NEW_END_DATE', {
                newEndDate: dayjs(endDate).format('DD.MM.YYYY'),
            });
        }

        if (this.request.customerType === 'AcademiaStudent') {
            endDate = new Date(this.request.endDate);
        } else if (today > endDate) {
            endDate = today;
        }

        return this.translateService.instant('MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.NEW_END_DATE', {
            newEndDate: extendDate(endDate, this.request.customerType === 'AcademiaStudent' ? 0 : 30, 'day').format('DD.MM.YYYY'),
        });
    }

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private translateService: TranslateService,
    ) {}

    close(): void {
        this.activeModal.close();
    }

    submit(): void {
        if (this.action === 'deny') {
            const payload: DenyTrialExtensionPayload = {
                rejectedReason: this.formGroup.get('message')?.value,
            };
            this.onSubmit.next(payload);
        } else {
            this.onSubmit.next();
        }
        this.activeModal.close();
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            message: ['', [Validators.required]],
        });
    }
}
